/**
 * MM Reassurance
 * Synchronise la pagination (dots) du carrousel mobile de la barre de réassurance.
 *
 * Le défilement lui-même est 100% CSS (scroll-snap) : si ce script ne se charge pas,
 * la section reste parfaitement utilisable, seuls les dots ne s'animent plus.
 */
(function () {
	'use strict';

	var SELECTOR = '[data-mm-reassurance]';

	function prefersReducedMotion() {
		return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	}

	function setup(root) {
		if (!root || root.dataset.mmReassuranceReady === 'true') return;

		var track = root.querySelector('[data-mm-reassurance-track]');
		var dots = Array.prototype.slice.call(root.querySelectorAll('[data-mm-reassurance-dot]'));

		if (!track || dots.length < 2) return;
		root.dataset.mmReassuranceReady = 'true';

		var items = Array.prototype.slice.call(track.children);
		var pending = false;

		function currentIndex() {
			var center = track.scrollLeft + track.clientWidth / 2;
			var index = 0;
			var closest = Infinity;

			for (var i = 0; i < items.length; i++) {
				var itemCenter = items[i].offsetLeft - track.offsetLeft + items[i].offsetWidth / 2;
				var distance = Math.abs(itemCenter - center);
				if (distance < closest) {
					closest = distance;
					index = i;
				}
			}

			return Math.min(index, dots.length - 1);
		}

		function sync() {
			pending = false;
			var index = currentIndex();

			for (var i = 0; i < dots.length; i++) {
				var isActive = i === index;
				dots[i].classList.toggle('is-active', isActive);
				dots[i].setAttribute('aria-current', isActive ? 'true' : 'false');
			}
		}

		function requestSync() {
			if (pending) return;
			pending = true;
			window.requestAnimationFrame(sync);
		}

		function goTo(index) {
			var item = items[index];
			if (!item) return;

			var left = item.offsetLeft - track.offsetLeft;

			try {
				track.scrollTo({ left: left, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
			} catch (error) {
				track.scrollLeft = left;
			}
		}

		track.addEventListener('scroll', requestSync, { passive: true });
		window.addEventListener('resize', requestSync, { passive: true });

		dots.forEach(function (dot, index) {
			dot.addEventListener('click', function () {
				goTo(index);
			});
		});

		root.mmReassuranceGoTo = goTo;
		sync();
	}

	function setupAll(scope) {
		var container = scope && scope.querySelectorAll ? scope : document;
		var roots = Array.prototype.slice.call(container.querySelectorAll(SELECTOR));

		if (scope && scope.matches && scope.matches(SELECTOR)) roots.push(scope);
		roots.forEach(setup);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			setupAll(document);
		});
	} else {
		setupAll(document);
	}

	/* Éditeur de thème : la section est réinjectée dans le DOM à chaque modification. */
	document.addEventListener('shopify:section:load', function (event) {
		setupAll(event.target);
	});

	document.addEventListener('shopify:block:select', function (event) {
		var root = event.target.closest ? event.target.closest(SELECTOR) : null;
		if (!root || typeof root.mmReassuranceGoTo !== 'function') return;

		var items = Array.prototype.slice.call(event.target.parentElement.children);
		root.mmReassuranceGoTo(items.indexOf(event.target));
	});
})();